/**
 * Utility for Web Notifications API (Browser Push Alerts)
 */

export const isNotificationSupported = (): boolean => {
  return typeof window !== "undefined" && "Notification" in window;
};

export const getNotificationPermission = (): NotificationPermission => {
  if (!isNotificationSupported()) return "denied";
  return Notification.permission;
};

export const requestNotificationPermission = async (): Promise<boolean> => {
  if (!isNotificationSupported()) return false;
  try {
    const permission = await Notification.requestPermission();
    if (permission === "granted") {
      localStorage.setItem("browserNotificationsEnabled", "true");
      return true;
    } else {
      localStorage.setItem("browserNotificationsEnabled", "false");
      return false;
    }
  } catch (error) {
    console.error("Error requesting notification permission:", error);
    return false;
  }
};

export const sendBrowserNotification = (
  title: string,
  options?: NotificationOptions & { onClickUrl?: string }
): Notification | null => {
  if (!isNotificationSupported() || Notification.permission !== "granted") {
    return null;
  }

  try {
    const defaultOptions: NotificationOptions = {
      icon: "/images/Seva-logo.png",
      badge: "/images/Seva-logo.png",
      silent: false,
      ...options,
    };

    const notification = new Notification(title, defaultOptions);

    if (options?.onClickUrl) {
      notification.onclick = (e) => {
        e.preventDefault();
        window.focus();
        window.location.href = options.onClickUrl!;
      };
    }

    return notification;
  } catch (error) {
    console.error("Error displaying notification:", error);
    return null;
  }
};
